import { hasArkKind } from "@arktype/schema";
import { isThunk, objectKindOf, printable, throwParseError } from "@arktype/util";
import { parseObjectLiteral } from "./objectLiteral.js";
import { parseTuple } from "./tuple.js";
export const parseObject = (def, ctx) => {
    const objectKind = objectKindOf(def);
    switch (objectKind) {
        case undefined:
            if (hasArkKind(def, "root"))
                return def;
            return parseObjectLiteral(def, ctx);
        case "Array":
            return parseTuple(def, ctx);
        case "RegExp":
            return ctx.$.node("intersection", {
                domain: "string",
                regex: def
            }, { prereduced: true });
        case "Function": {
            const resolvedDef = isThunk(def) ? def() : def;
            if (hasArkKind(resolvedDef, "root"))
                return resolvedDef;
            return throwParseError(writeBadDefinitionTypeMessage("Function"));
        }
        default:
            return throwParseError(writeBadDefinitionTypeMessage(objectKind ?? printable(def)));
    }
};
export const writeBadDefinitionTypeMessage = (actual) => `Type definitions must be strings or objects (was ${actual})`;
